'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
var PaginationArrow = require('./PaginationArrow.js');
var usePagination = require('./usePagination.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["defaultPage", "page", "count", "renderItem", "isDisabled", "onChange", "getAriaLabel", "getText", "children", "className"];
var defaultGetText = function defaultGetText(page, count) {
  return "Seite ".concat(page, " von ").concat(count);
};

/**
 * Compact pagination
 *
 * A pagination that displays a previous and next button and the number of pages.
 * Suited for small displays and/or pages with a small space.
 */
var CompactPagination = react.forwardRef(function (props, ref) {
  var styles = react.useMultiStyleConfig('CompactPagination', props);
  var _omitThemingProps = react.omitThemingProps(props),
    defaultPageProp = _omitThemingProps.defaultPage,
    pageProp = _omitThemingProps.page,
    countProp = _omitThemingProps.count,
    renderItemProp = _omitThemingProps.renderItem,
    isDisabledProp = _omitThemingProps.isDisabled,
    onChangeProp = _omitThemingProps.onChange,
    getAriaLabelProp = _omitThemingProps.getAriaLabel,
    _omitThemingProps$get = _omitThemingProps.getText,
    getText = _omitThemingProps$get === void 0 ? defaultGetText : _omitThemingProps$get,
    children = _omitThemingProps.children,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var _usePagination = usePagination.usePagination({
      defaultPage: defaultPageProp,
      page: pageProp,
      count: countProp,
      renderItem: renderItemProp,
      isDisabled: isDisabledProp,
      onChange: onChangeProp,
      getAriaLabel: getAriaLabelProp
    }),
    page = _usePagination.page,
    count = _usePagination.count,
    handleClick = _usePagination.handleClick,
    getAriaLabel = _usePagination.getAriaLabel,
    renderItem = _usePagination.renderItem,
    isDisabled = _usePagination.isDisabled;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.nav, _extends__default["default"]({
    className: utils.cx('chakra-compact-pagination', className),
    role: "pagination",
    __css: styles.container
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, children ? children : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, renderItem(PaginationArrow.PaginationPrevArrow, {
    onClick: function onClick(event) {
      return handleClick(event, page - 1);
    },
    'aria-label': getAriaLabel(page - 1, 'prev'),
    isDisabled: isDisabled || page === 1,
    className: 'chakra-compact-pagination-arrow'
  }, page - 1), /*#__PURE__*/React__default["default"].createElement(react.chakra.span, {
    className: "chakra-compact-pagination-text",
    __css: styles.text,
    "aria-label": getText(page, count)
  }, getText(page, count)), renderItem(PaginationArrow.PaginationNextArrow, {
    onClick: function onClick(event) {
      return handleClick(event, page + 1);
    },
    'aria-label': getAriaLabel(page + 1, 'next'),
    isDisabled: isDisabled || page + 1 > count,
    className: 'chakra-compact-pagination-arrow'
  }, page + 1))));
});
CompactPagination.displayName = 'CompactPagination';
exports.CompactPagination = CompactPagination;